var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found display-1"},[_c('div',[_vm._v("\n        Page not found "),_c('br'),_c('v-btn',{attrs:{"color":"primary","to":"/"}},[_vm._v("Back to home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }